import { useAutoneTranslation } from '@autone/translations';
import { type FC } from 'react';

import { Button } from '../../../../atoms';

interface SeeDetailsButtonProps {
  onClick: () => void;
}

export const SeeDetailsButton: FC<SeeDetailsButtonProps> = ({ onClick }) => {
  const { common } = useAutoneTranslation();
  return (
    <Button
      onClick={onClick}
      variant="secondary"
      size="sm"
      className="w-full"
      id="see-details-button"
      aria-label="See details"
    >
      {common('data-age.global-widget.see-details')}
    </Button>
  );
};
